module.exports = __webpack_public_path__ + "img/horizontal_7_7_9016.248b3589.png";